import { mapGetters, mapActions } from 'vuex'
import { getMasterDataText } from '@/helpers'

export default {
  computed: {
    ...mapGetters({
      posSettings: 'getPosSetting',
      diningName: 'getPosSelectedDiningName',
      queue_number: 'getPosSelectedQueueNumber',
      table_number: 'getPosSelectedTableNumber', // selected table_number
    }),
    diningOptions() {
      const mapIcon = {
        '{dine_in}': 'fas fa-utensils',
        '{take_away}': 'fas fa-gift',
        '{delivery}': 'fas fa-motorcycle',
        '{self_pick_up}': 'fas fa-hand-holding',
        '{menu_online}': 'icon fas fa-mobile-alt',
      }
      return this.posSettings.dining.options
        .filter((item) => item.is_active)
        .map((item) => {
          return {
            ...item,
            icon: mapIcon[item.name],
            text: getMasterDataText(item.name, this.$t),
          }
        })
    },
  },
  methods: {
    ...mapActions([
      'setPosSection',
      'setPosSelectedDiningName',
      'clearPosSelectedDiningName',
      'setDiningNameForQueueAndTable',
    ]),
    onDeselectDining() {
      this.clearPosSelectedDiningName({
        queue_number: this.queue_number,
        table_number: this.table_number,
      })
      this.setPosSection('choose-product')
    },
    onSelectDining(value) {
      this.setPosSelectedDiningName({ name: value })
      this.setDiningNameForQueueAndTable()
      this.setPosSection('choose-product')
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/pos/diningList.js